import { jsxs, jsx } from "react/jsx-runtime";
import { motion } from "motion/react";
import React__default, { useRef, useState, useEffect } from "react";
import { cn } from "../lib/utils.js";
const StoreCarousel = ({ children, styleProps, gap = 15, ...props }) => {
  const carouselRef = useRef(null);
  const itemRefs = useRef([]);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const updateArrowVisibility = () => {
    if (!carouselRef.current) return;
    const { scrollLeft, scrollWidth, clientWidth } = carouselRef.current;
    setShowLeftArrow(scrollLeft > 10);
    setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 10);
  };
  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;
    updateArrowVisibility();
    const handleScroll = () => {
      updateArrowVisibility();
    };
    carousel.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", updateArrowVisibility);
    return () => {
      carousel.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", updateArrowVisibility);
    };
  }, [children]);
  const scroll = (direction) => {
    if (!carouselRef.current) return;
    const scrollAmount = carouselRef.current.clientWidth * 0.8;
    const targetScroll = carouselRef.current.scrollLeft + (direction === "right" ? scrollAmount : -scrollAmount);
    carouselRef.current.scrollTo({
      left: targetScroll,
      behavior: "smooth"
    });
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "tw:relative tw:w-full tw:max-w-full tw:overflow-hidden tw:flex tw:justify-start tw:items-center store-carousel-container"
      ),
      ...styleProps,
      children: [
        /* @__PURE__ */ jsx("style", { children: `
        .store-carousel-scroll::-webkit-scrollbar {
          display: none;
        }
        .store-carousel-arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: white;
          border: 1px solid #e5e7eb;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index: 10;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          opacity: 0;
          transition: opacity 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
          pointer-events: none;
        }
        .store-carousel-container:hover .store-carousel-arrow {
          opacity: 1;
          pointer-events: auto;
        }
        .store-carousel-arrow:hover {
          background: #f9fafb;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
        .store-carousel-arrow:active {
          transform: translateY(-50%) scale(0.95);
        }
        .store-carousel-arrow-left {
          left: 8px;
        }
        .store-carousel-arrow-right {
          right: 8px;
        }
        .store-carousel-arrow svg {
          width: 16px;
          height: 16px;
          color: #374151;
        }
      ` }),
        showLeftArrow && /* @__PURE__ */ jsx(
          "button",
          {
            className: "store-carousel-arrow store-carousel-arrow-left",
            onClick: () => scroll("left"),
            "aria-label": "Scroll left",
            children: /* @__PURE__ */ jsx("svg", { fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M15 19l-7-7 7-7" }) })
          }
        ),
        showRightArrow && /* @__PURE__ */ jsx(
          "button",
          {
            className: "store-carousel-arrow store-carousel-arrow-right",
            onClick: () => scroll("right"),
            "aria-label": "Scroll right",
            children: /* @__PURE__ */ jsx("svg", { fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M9 5l7 7-7 7" }) })
          }
        ),
        /* @__PURE__ */ jsx(
          motion.div,
          {
            ref: carouselRef,
            style: {
              gap: `${gap}px`,
              scrollbarWidth: "none",
              // Firefox
              msOverflowStyle: "none"
              // IE/Edge
            },
            className: cn("store-carousel-scroll", "tw:flex tw:overflow-auto tw:[scroll-snap-type:x_mandatory]"),
            ...props,
            children: React__default.Children.map(children, (child, index) => /* @__PURE__ */ jsx(
              "div",
              {
                className: "tw:snap-start tw:shrink-0",
                ref: (ref) => {
                  const current = itemRefs.current[index];
                  if (current && !ref) {
                    itemRefs.current = itemRefs.current.filter((_, i) => i !== index);
                    return;
                  }
                  itemRefs.current[index] = ref;
                },
                children: child
              },
              index
            ))
          }
        )
      ]
    }
  );
};
export {
  StoreCarousel as default
};
//# sourceMappingURL=StoreCarousel.js.map
